module.exports = __webpack_public_path__ + "static/media/glass.6caee995.svg";